module.exports = __WEBPACK_EXTERNAL_MODULE_35__;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 35
// module chunks = 0